var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 3L7.99947 7.5L3.49987 3L2 4.5L6.4996 9L2 13.5L3.49987 15L7.99947 10.5L12.5001 15L14 13.5L9.5004 9L14 4.5L12.5001 3Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/Reject_Icon.69dcfaf7e3817aa7d6d8c9e712139d96.svg";
export { ForwardRef as ReactComponent };